import { CustomerDBStatus, CustomersBySerial } from '@ip6m/types';
import { getRepository, Repository } from 'typeorm';
import { AddressEntity } from '../../models/address.entity';
import { CityEntity } from '../../models/city.entity';
import { CustomerEntity } from '../../models/customer.entity';
import { GpsCoordinatesEntity } from '../../models/gpscoordinates.entity';
import { ServiceEntity } from '../../models/service.entity';
import { ServiceTypeEntity } from '../../models/servicetype.entity';
import { StreetEntity } from '../../models/street.entity';

import { Injectable, OnApplicationBootstrap } from "@nestjs/common";
import { Cron } from "@nestjs/schedule";

@Injectable()
export class DatabaseService implements OnApplicationBootstrap {
  serviceRepo: Repository<ServiceEntity>;
  customerRepo: Repository<CustomerEntity>;
  locationRepo: Repository<AddressEntity>;
  streetRepo: Repository<StreetEntity>;
  gpsCoordRepo: Repository<GpsCoordinatesEntity>
  cityRepository: Repository<CityEntity>
  serviceTypeRepo: Repository<ServiceTypeEntity>
  dbStatus: CustomerDBStatus;


  
  //Remove unreferenced records
  @Cron('00 4 * * * ')
  async cleanUpDatabase() {
   
      let addresses = await this.locationRepo.find()
      for (let index = 0; index < addresses.length; index++) {
         await this.locationRepo.createQueryBuilder('location')
         .delete()
         .from(AddressEntity)
         .where({addressId:addresses[index].addressId})
         .execute()
         .catch((err)=>{})
      }
     

      let gps = await this.gpsCoordRepo.find()
      for (let index = 0; index < gps.length; index++) {
         await this.locationRepo.createQueryBuilder('gps')
         .delete()
         .from(GpsCoordinatesEntity)
         .where({gpsCoordId:gps[index].gpsCoordId})
         .execute()
         .catch((err)=>{})
      }
      
  }



  async onApplicationBootstrap() {
    this.serviceRepo = getRepository(ServiceEntity);
    this.customerRepo = getRepository(CustomerEntity);
    this.locationRepo = getRepository(AddressEntity);
    this.streetRepo = getRepository(StreetEntity);
    this.gpsCoordRepo=getRepository(GpsCoordinatesEntity)
    this.serviceTypeRepo=getRepository(ServiceTypeEntity)
    this.cityRepository=getRepository(CityEntity)
    this.initDBStatus();
    
  }

  async getData(sn: string = '') {
    console.log(sn);
    let resp: CustomersBySerial = {};
    let queryBuilder = this.serviceRepo.createQueryBuilder("service")
        .leftJoinAndSelect("service.customerId", "customer")
        .leftJoinAndSelect("service.location", "location")
        .leftJoinAndSelect("location.street", "street")
        .leftJoinAndSelect("street.city", "city")
        .leftJoinAndSelect("location.gpsCoord", "gps");

    if(sn.length) {
      queryBuilder = queryBuilder.where({ ontSerialNum: sn });
    }

    const data = await queryBuilder.getMany();
    
    data.forEach(record => {
        if(record.location) {
            if(record.location.street) {
                var street = record.location.street;
                if(street.city) {
                    var city = street.city;
                }
            }
            if(record.location.gpsCoord) {
                var gps = record.location.gpsCoord;
            }
        }

        resp[record.ontSerialNum.toUpperCase()] = {
            serviceId: record.serviceId.toString(),
            customerId: record.customerId ? record.customerId.customerId.toString() : null,
            name: record.customerId ? record.customerId.name : null,
            zipcode: record.location ? record.location.zipcode : null,
            city: city ? city.name : null,
            street: street ? street.name : null,
            houseNum: record.location ? record.location.houseNum : null,
            gpsLatitude: gps ? gps.gpsLatitude : null,
            gpsLongitude: gps ? gps.gpsLongitude : null,
            ontSn: record.ontSerialNum,
            networkNode: null
        }
        
    })

    return resp;
  }

  constructor() {}

  get getDBStatus(): CustomerDBStatus {
    return this.dbStatus;
  }

 
 



  




  async initDBStatus() {
    this.dbStatus = {
      status: true,
      provider: 'default',
      title: 'Local Users',
      description: 'Helyi ügyfelek',
      customerNum: await this.customerRepo.count(),
      ontNum: await this.serviceRepo.count(),
    };
    console.log(this.dbStatus);
  }
}
